import React from 'react'
import cx from 'classnames'
import { links } from 'helpers'
import { connect } from 'redaction'

import Link from 'components/ui/Link/Link'

import s from './BurgerMenuList.scss'


const BurgerMenuList = ({ className, layers }) => (
  <div className={cx(s.container, className)}>
    <div className={s.burgerMenuList}>
      {
        layers.map(({ id, title, menu, link, toOLD, actions }) => (
          <div key={id} className={s.linkContainer}>
            <Link
              className={s.link}
              title={title}
              to={toOLD ? null : link}
              toOLD={!toOLD ? null : link}
            />
            {
              actions.map(({ action, title }) => (
                <Link
                  key={title}
                  className={s.subLink}
                  title={title}
                  to={toOLD ? null : link}
                  toOLD={!toOLD ? null : link + `${/\?/.test(link) ? '&' : '?'}action=${action}`}
                />
              ))
            }
          </div>
        ))
      }
    </div>
  </div>
)


export default connect({
  layers: (state) => {
    const { me: { layers } } = state
    const { routing: { locationBeforeTransitions: { pathname } } } = state

    const reactLinks = Object.keys(links).map((linkKey) => links[linkKey].root)

    return layers.filter(({ actions, menu }) => {
      return actions || menu === 'fullscreen'
    })
      .map(({ id, link, title, menu, actions }) => ({
        id,
        link,
        menu,
        title,
        actions: actions || [],
        isActive: pathname.includes(link),
        toOLD: !reactLinks.includes(link),
      }))
  },
})(BurgerMenuList)
